import { EnrollmentCourse } from '@/models/mamata/enrollment-course.model';
import { UndergradLive } from './undergrad-live.model';

export enum DegreeType {
  BACHARELADO = 'BACHARELADO',
  LICENCIATURA = 'LICENCIATURA',
  TECNOLOGO = 'TECNOLOGO',
}

export interface StellateDegreeType {
  id: string;
  name: string;
  slug: string;
  dexCourseId: number;
  faculLiveVideo?: UndergradLive[];
}

export interface UndergradCourses {
  id: string;
  name: string;
  slug: string;
  degreeType: DegreeType;
  dexCourseId: number;
  courseEnrollment: EnrollmentCourse;
  lives: { [key: string]: UndergradLive };
}

export type UndergradCoursesInfo = Omit<UndergradCourses, 'courseEnrollment'>;
